import { TOKEN_TYPE } from '@oup/shared-node-browser/constants';
import { userRoles } from '@oup/shared-node-browser/user.js';

export default function setUserTaskInStorage(userTokenData = {}) {
  const { tokenType, role, userId, orgId, classId } = userTokenData || {};
  const taskUrl = classId ? `/myTasks?classId=${classId}` : '/myTasks';

  if (tokenType !== TOKEN_TYPE.INVITATION_OPT_TEST || role !== userRoles.LEARNER || !userId || !orgId) {
    return;
  }

  sessionStorage.setItem('userTask', JSON.stringify({ userId, orgId, taskUrl }));
}
